module.exports = "../../app/cells/components/discipline_course_banner_cell.rb";